/**
 * Calculates the linear parameter produced by the interpolant value within the range.
 *
 * @param start The start value.
 * @param end The end value.
 * @param value The value between start and end.
 * @returns Returns the percentage of value between start and end.
 * @example
 *
 * inverseLerp(5, 10, 7.5)
 * // => 0.5
 *
 * inverseLerp(-10, 10, 5)
 * // => 0.75
 */
export function inverseLerp(start: number, end: number, value: number): number {
  return (value - start) / (end - start);
}
